import Resilience from './Resilience';

export default Resilience;
